import { Duration } from 'luxon'

import { PLAYBACK_RATE, QUALITIES } from './constants'

// 再生速度倍率オプション生成用Util
export const toPlaybackRateOption = (playbackRate: PLAYBACK_RATE) => ({
  label: Number.isInteger(playbackRate)
    ? `${playbackRate}.0x`
    : `${playbackRate}x`,
  value: playbackRate,
})

// 動画品質オプション生成用Util
export const toQualityOption = (quality: QUALITIES) => ({
  label: `${quality}p`,
  value: quality,
})

// 時間表示用のUtil
const SECONDS_IN_AN_HOUR = 3600

export const formatTime = (seconds = 0) =>
  seconds >= SECONDS_IN_AN_HOUR
    ? Duration.fromObject({ seconds }).toFormat('hh:mm:ss')
    : Duration.fromObject({ seconds }).toFormat('mm:ss')
